export enum OrderActions {
  CREATE_ERROR = '[OrderActions] CREATE_ERROR',
  CREATE_REQUEST = '[OrderActions] CREATE_REQUEST',
  CREATE_SUCCESS = '[OrderActions] CREATE_SUCCESS',
  DELETE_ERROR = '[OrderActions] DELETE_ERROR',
  DELETE_REQUEST = '[OrderActions] DELETE_REQUEST',
  DELETE_SUCCESS = '[OrderActions] DELETE_SUCCESS',
  DOWNLOAD_AVAILABLE = '[OrderActions] COMPLETED',
  FORM_CHANGE = '[OrderActions] FORM_CHANGE',
  TRACK_ORDER_PROGRESS = '[OrderActions] TRACK_ORDER_PROGRESS',
  UPDATE_ERROR = '[OrderActions] UPDATE_ERROR',
  UPDATE_LIST_ERROR = '[OrderActions] UPDATE_LIST_ERROR',
  UPDATE_LIST_REQUEST = '[OrderActions] UPDATE_LIST_REQUEST',
  UPDATE_LIST_SUCCESS = '[OrderActions] UPDATE_LIST_SUCCESS',
  UPDATE_ORDER_PROGRESS_ERROR = '[OrderActions] UPDATE_ORDER_PROGRESS_ERROR',
  UPDATE_ORDER_PROGRESS_REQUEST = '[OrderActions] UPDATE_ORDER_PROGRESS_REQUEST',
  UPDATE_ORDER_PROGRESS_SUCCESS = '[OrderActions] UPDATE_ORDER_PROGRESS_SUCCESS',
  UPDATE_REQUEST = '[OrderActions] UPDATE_REQUEST',
  UPDATE_SUCCESS = '[OrderActions] UPDATE_SUCCESS',
}
